"use client";

import { type ReactNode } from "react";

interface StepCardProps {
	children: ReactNode;
	className?: string;
}

/**
 * The visual card frame shared by step content and the step loader.
 * Does not participate in step transitions — use `StepContainer` for that.
 */
export const StepCard = ({ children, className = "" }: StepCardProps) => (
	<div
		className={`relative flex flex-col items-center justify-center gap-2 ${className}`}
	>
		{children}
	</div>
);
